import { render, staticRenderFns } from "./assessment-notes-display.vue?vue&type=template&id=14a00e60&scoped=true&"
import script from "./assessment-notes-display.vue?vue&type=script&lang=js&"
export * from "./assessment-notes-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a00e60",
  null
  
)

export default component.exports